//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { PracticeLogNotificationInputItem } from './PracticeLogNotificationInputItem';
import { PracticeLogType } from './Enums';

export class PracticeLogFeedbackNotificationInputItem extends PracticeLogNotificationInputItem {
    override readonly FeedbackType: PracticeLogType = PracticeLogType.Feedback;

    constructor(initializer?: Partial<Omit<PracticeLogFeedbackNotificationInputItem, "FeedbackType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PracticeLogFeedbackNotificationInputItem";
}
